import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { classroomStudentsSlice, selectClassroomStudents } from "../../../redux/classroom/classroomStudentsSlice";
import { classroomDeleteStudent } from "../../../redux/classroom/classroomRemoveStudentSlice";
import PrizaAvatarGrid, { PrizaAvatarGridItem } from "../../../features/base/grid/PrizaAvatarGrid";
import { useEffect, useMemo, useState } from "react";
import { Box, Button, Stack, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { NamedObject } from "../../../redux/object/namedObject";

import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import BadgedAvatar from "../../../features/base/BadgedAvatar";
import { assertThumbnailUrl } from "../../../redux/common";

import GridOnIcon from '@mui/icons-material/GridOn';
import DnsIcon from '@mui/icons-material/Dns';

interface ExistingStudentsListProps {
    schoolId: string;
    classroomId: string;
}

const ExistingStudentsList = ({ schoolId, classroomId }: ExistingStudentsListProps) => {
    const dispatch = useAppDispatch();
    const classroomStudents = useSelector(selectClassroomStudents);
    const [table, setTable] = useState(true);

    const request = useMemo(() => ({ schoolId, classroomId }), [schoolId, classroomId]);
    useEffect(() => {
        dispatch(classroomStudentsSlice.actions.check(request));
    }, [classroomStudents, request]);

    const list = classroomStudents.list || [];
    const mapped: PrizaAvatarGridItem[] = list.map((item) => {
        const obj = NamedObject.student(item);
        return {
            image: obj.thumbnail,
            title: obj.display,
            subtitle: item.name,
            extra: <Tooltip title="Remover aluno da sala de aula">
                <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                    <Button variant="outlined" size="small" color='error' onClick={() => {
                        dispatch(classroomDeleteStudent({ classroomId: classroomId, student: item }));
                    }}>
                        <PersonRemoveIcon />
                    </Button>
                </Box>
            </Tooltip>,
        } as PrizaAvatarGridItem;
    });

    const buildContent = !table ? undefined : () => {
        return <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Aluno</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Nome</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Nascimento</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Matricula</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Remover</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((item) => {
                        return <TableRow key={item.id} hover
                            // onClick={() => {
                            //     dispatch(studentSlice.actions.clean());
                            //     navigate(routeStudent(schoolId, item.id, classroomId));
                            // }}
                            >
                            <TableCell>
                                <Stack direction="row" alignItems="center">
                                    <BadgedAvatar
                                        title={item.nickname || item.name}
                                        avatar={assertThumbnailUrl(item.url)}
                                        size="32px"
                                        marginRight={1}
                                    />
                                    {item.nickname || item.name}
                                </Stack>
                            </TableCell>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>{item.birthDate}</TableCell>
                            <TableCell>{item.schoolNumber}</TableCell>
                            <TableCell>
                                <Button variant="outlined" size="small" color='error' onClick={() => {
                                    dispatch(classroomDeleteStudent({ classroomId: classroomId, student: item }));
                                }}>
                                    <PersonRemoveIcon />
                                </Button>
                            </TableCell>
                        </TableRow>;
                    })}
                </TableBody>
            </Table>
        </>;
    };


    const buttons = [];
    buttons.push({
        label: table ? <DnsIcon /> : <GridOnIcon />,
        click: () => {
            setTable(!table);
        }
    });

    return <PrizaAvatarGrid list={mapped}
        toolbar={{
            label: "Alunos da Sala de Aula",
            buttons: buttons
        }}
        state={classroomStudents.state}
        retry={() => { dispatch(classroomStudentsSlice.actions.clean()); }}
        buildContent={buildContent}
        messages={{
            empty: "Nenhum aluno associado a esta sala de aula.",
            error: "Erro ao carregar alunos."
        }}
    />;

};

export default ExistingStudentsList;